import thunkMiddleware from "redux-thunk";
import rootReducer from "store/reducers/rootReducer";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { productionServer } from "utils/commonMethods";

const middlewares = [thunkMiddleware];

const devTools = productionServer()
  ? applyMiddleware(...middlewares)
  : composeWithDevTools(applyMiddleware(...middlewares));

//Compose enables devtools debugging.
const reduxStore = (function (initialState = {}) {
  return createStore(rootReducer, initialState, devTools);
})();

export default reduxStore;
